export const positionVariants = {
  // extend: layoutVariants,
  variants: {
    position: {
      static: "oui-static",
      fixed: "oui-fixed",
      absolute: "oui-absolute",
      relative: "oui-relative",
      sticky: "oui-sticky",
    },
    zIndex: {
      0: "oui-z-0",
      10: "oui-z-10",
      20: "oui-z-20",
      30: "oui-z-30",
      40: "oui-z-40",
      50: "oui-z-50",
      auto: "oui-z-auto",
    },
  },
};
